
const readTextFile = async (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            return resolve(reader.result);
        }
        reader.onerror = (err) => {
            return reject(err)
        }
        reader.readAsText(file);
    })
}

const readAsArrayBuffer = async (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            return resolve(reader.result);
        }
        reader.onerror = (err) => {
            return reject(err)
        }
        reader.readAsText(file)
    })
}

const readAsDataUrl = async (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            return resolve(reader.result);
        }
        reader.onerror = (err) => {
            return reject(err)
        }
        reader.readAsDataURL(file)
    })
}

const readAsBase64 = async (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            const base64String = reader.result.split(',')[1]; // base64 string
            return resolve(base64String);
        }
        reader.onerror = (err) => {
            return reject(err)
        }
        reader.readAsDataURL(file)
    })
}

function base64ToBlobUrl(base64, mimeType) {
    // Base64 verisini çözümleyip binary veri elde edin
    const byteCharacters = atob(base64);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }

    // Binary veriyi bir Blob nesnesine dönüştür
    const blob = new Blob(byteArrays, { type: mimeType });

    // Blob'dan bir URL oluştur
    const blobUrl = URL.createObjectURL(blob);

    return blobUrl;
}

const FileHelper = {
    readTextFile,
    readAsArrayBuffer,
    readAsBase64,
    readAsDataUrl,
    base64ToBlobUrl
}

export default FileHelper
